import {
  AlertDescription,
  AlertTitle,
} from "Components/TextContext/commonComponentEnums";

import { StyledAlert } from "App/global-style";
import { AlertType } from "Components/Form/Alert";
import { useTexts } from "Components/TextContext";
import { AddProductToCartEntity } from "Store/addProductToCart/interfaces";
import { PriceCalculationResponseEntity } from "Store/priceCalculation/priceCalculationInterfaces";
import React from "react";

interface Props {
  priceCalculation?: PriceCalculationResponseEntity;
  addProductToCart?: AddProductToCartEntity;
}

export const BackendErrorAlert = ({
  priceCalculation,
  addProductToCart,
}: Props): React.ReactElement | null => {
  const { getText } = useTexts();
  if (priceCalculation?.error || addProductToCart?.error) {
    return (
      <StyledAlert
        marginTop="24px"
        title={getText(AlertTitle.SOMETHING_WENT_WRONG)}
        description={getText(AlertDescription.CALL_US_ERROR)}
        type="error"
        alertId="backendErrorAlert"
        alertType={AlertType.SYSTEM_ERROR_ALERT}
        fluid
      />
    );
  }
  return null;
};
